export const iconRegistry = {
    users: "fa-regular fa-users",
    user: "fa-regular fa-user",
    bell: "fa-regular fa-bell-concierge",
    grid: "fa-regular fa-grid-2",
    organizations: "fa-regular fa-sitemap",
    clients: 'fa-regular fa-people-group',
    // dashboard: "fa-regular fa-shapes",
    // dashboard: "fa-regular fa-table-cells-merge",
    dashboard: "fa-regular fa-table-tree",
    communications: "fa-regular fa-message-dots",
    documents: "fa-regular fa-file-lines",
    gears: "fa-regular fa-gears",
    gear: "fa-regular fa-gear",
    edit: "fa-regular fa-pen-field",
    calendar: "fa-regular fa-calendar-clock",
    list: "fa-regular fa-list",
    'list-timeline': "fa-regular fa-list-timeline",
    'chevron-right': "fa-regular fa-chevron-right",
    'chevron-left': "fa-regular fa-chevron-left",
    'chevron-down': "fa-regular fa-chevron-down",
    'question-circle': "fa-light fa-circle-question",
    search: "fa-light fa-magnifying-glass",
    info: "fa-regular fa-circle-info",
    copy: "fa-regular fa-copy",
    checkmark: "fa-sharp fa-solid fa-square-check",
    history: "fa-regular fa-history",
    'history-records': "fa-regular fa-rectangle-history",
    minimize: "fa-regular fa-window-minimize",
    close: "fa-light fa-xmark",
    'heart-holding-hand': "fa-regular fa-hand-holding-heart",
    'arrow-right-to-line': "fa-light fa-arrow-right-to-line"
};

export const vmsIcons = {
    COORD_VOL: iconRegistry['users'],
    COORD_OPP: iconRegistry['heart-holding-hand'],
    COORD_AE: iconRegistry['list-timeline'],
    COORD_ORG: iconRegistry['organizations'],
    COORD_MEM: iconRegistry['clients'],
    COORD_AFF: iconRegistry['grid'],
    COORD_DASHBOARD: iconRegistry['dashboard'],
    EXPAND_LEFT_PANEL: iconRegistry['chevron-right'],
    EXPAND_RIGHT_PANEL: iconRegistry['chevron-left'],
    COLLAPSE_RIGHT_PANEL: iconRegistry['chevron-right'],
    ADMIN_OPT: iconRegistry['gear'],
    NAV_HISTORY: iconRegistry['history'],
    NAV_MINIMIZED: iconRegistry['history-records']
};
